var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72344 20.3C3.5401 20.1167 3.44844 19.8834 3.44844 19.6C3.44844 19.3167 3.5401 19.0834 3.72344 18.9L13.2734 9.35002C12.9734 8.65002 12.9318 7.85835 13.1484 6.97502C13.3651 6.09169 13.8401 5.30002 14.5734 4.60002C15.4568 3.71669 16.4401 3.20002 17.5234 3.05002C18.6068 2.90002 19.4901 3.16669 20.1734 3.85002C20.8568 4.53335 21.1234 5.41669 20.9734 6.50002C20.8234 7.58335 20.3068 8.56669 19.4234 9.45002C18.7234 10.1834 17.9318 10.6584 17.0484 10.875C16.1651 11.0917 15.3734 11.05 14.6734 10.75L13.4234 12L20.3234 18.9C20.5068 19.0834 20.5984 19.3167 20.5984 19.6C20.5984 19.8834 20.5068 20.1167 20.3234 20.3C20.1234 20.5 19.8901 20.6 19.6234 20.6C19.3568 20.6 19.1234 20.5 18.9234 20.3L12.0234 13.45L5.12344 20.3C4.92344 20.5 4.6901 20.6 4.42344 20.6C4.15677 20.6 3.92344 20.5 3.72344 20.3ZM7.37344 12.45L4.37344 9.45002C3.62344 8.70002 3.18594 7.82502 3.06094 6.82502C2.93594 5.82502 3.12344 4.88335 3.62344 4.00002C3.7901 3.71669 4.0401 3.55835 4.37344 3.52502C4.70677 3.49169 4.99844 3.60835 5.24844 3.87502L10.5734 9.25002L7.37344 12.45Z",
    fill: "#104239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeIcon);
export default __webpack_public_path__ + "static/media/recipe-icon.7fc4211aa7cebc5042ca6c45a8933861.svg";
export { ForwardRef as ReactComponent };